// hooks/useUsername.js
import { useState, useEffect } from "react";

const useUserID = () => {
    const [userID, setUserID] = useState(null);

    useEffect(() => {
        const storedData = localStorage.getItem('user');
        const userDetails = storedData ? JSON.parse(storedData) : null;
        if (userDetails && userDetails.userID) {
            setUserID(userDetails.userID);
        }
    }, []);

    return userID;
};

export default useUserID;
